export class PagoConceptoRequest {
     mensaje:string;
	 resultado:number;
	 tokenid:string  ;
    transactionToken:string;
	 purchasenumber:string ;
	 productid:string ;
	 amount:string;
	 hcurrency:string;
	 authorizedamount:string;
	 authorizationcode:string ;
	 actioncode:string;
	 tracenumber:string ;
	 transactiondate:string ;
	 transactionid:string ;
	 currency:string;
	 terminal:string  ;
	 ecidescription:string  ;
	 eci:string;
	 brand:string ;
	 card:string ;
	 merchant:string ;
	 status:string ;
	 adquirente:string ;
	 actiondescription:string ;
	 idunico:string ;
	 processcode:string ;
	 recurrencestatus:string ;
	 idPagoElectronico:number;
	 consultadoNiubiz:string;	
	 codalumno:string;
     constructor(){
        this.mensaje="";
        this.resultado=0;
        this.tokenid=""  ;
        this.purchasenumber="" ;
        this.transactionToken="";
        this.productid="" ;
        this.amount="";
        this.hcurrency="";
        this.authorizedamount="";
        this.authorizationcode="" ;
        this.actioncode="";
        this.tracenumber="" ;
        this.transactiondate="" ;
        this.transactionid="" ;
        this.currency="";
        this.terminal=""  ;
        this.ecidescription=""  ;
        this.eci="";
        this.brand="" ;
        this.card="" ;
        this.merchant="" ;
        this.status="" ;
        this.adquirente="" ;
        this.actiondescription="" ;
        this.idunico="" ;
        this.processcode="" ;
        this.recurrencestatus="" ;
        this.idPagoElectronico=0;
        this.consultadoNiubiz="";	
        this.codalumno="";

     }
}
